import http from '../../../lib/http/httpClient';
import { TrackingData, TrackingMapData } from '../../../types/tracking';

export const getTrackingData = async (cnNumber: string): Promise<TrackingData> => {
    return http.get<TrackingData>(`/api/v1/cp/track?cn_number=${cnNumber}`);
};

export const getTrackingMapData = async (cnNumber: string): Promise<TrackingMapData> => {
    return http.get<TrackingMapData>(`/api/v1/cp/track/map?cn_number=${cnNumber}`);
};

export const getPublicTrackingData = async (token: string): Promise<TrackingData> => {
    return http.get(`/api/v1/cp/track/public?token=${encodeURIComponent(token)}`);
};

export const getPublicTrackingMapData = async (cnNumber: string): Promise<TrackingMapData> => {
    return http.get(`/api/v1/cp/track/map/public?cn_number=${encodeURIComponent(cnNumber)}`);
};
